export const NO_PERMISSION_REQUIRED = `no-permission-required`;
export const INVENTORY_VIEW_PERMISSION = `inventory-view-permission`;
export const INVENTORY_CREATE_PERMISSION = `inventory-create-permission`;
export const INVENTORY_EDIT_PERMISSION = `inventory-edit-permission`;
export const INVENTORY_DELETE_PERMISSION = `inventory-delete-permission`;
export const CUTTING_VIEW_PERMISSION = `cutting-view-permission`;
export const CUTTING_CREATE_PERMISSION = `cutting-create-permission`;
export const CUTTING_EDIT_PERMISSION = `cutting-edit-permission`;
export const CUTTING_DELETE_PERMISSION = `cutting-delete-permission`;
export const FOLDING_VIEW_PERMISSION = `folding-view-permission`;
export const FOLDING_CREATE_PERMISSION = `folding-create-permission`;
export const FOLDING_EDIT_PERMISSION = `folding-edit-permission`;
export const FOLDING_DELETE_PERMISSION = `folding-delete-permission`;
export const PACKING_VIEW_PERMISSION = `packing-view-permission`;
export const PACKING_CREATE_PERMISSION = `packing-create-permission`;
export const PACKING_EDIT_PERMISSION = `packing-edit-permission`;
export const PACKING_DELETE_PERMISSION = `packing-delete-permission`;
export const ASSIGNMENT_VIEW_PERMISSION = `assignment-view-permission`;
export const ASSIGNMENT_CREATE_PERMISSION = `assignment-create-permission`;
export const ASSIGNMENT_EDIT_PERMISSION = `assignment-edit-permission`;
export const ASSIGNMENT_DELETE_PERMISSION = `assignment-delete-permission`;
export const SEWING_VIEW_PERMISSION = `sewing-view-permission`;
export const SEWING_CREATE_PERMISSION = `sewing-create-permission`;
export const SEWING_EDIT_PERMISSION = `sewing-edit-permission`;
export const SEWING_DELETE_PERMISSION = `sewing-delete-permission`;
export const STORE_REQUISITION_VIEW_PERMISSION = `store-requisition-view-permission`;
export const STORE_REQUISITION_CREATE_PERMISSION = `store-requisition-create-permission`;
export const STORE_REQUISITION_EDIT_PERMISSION = `store-requisition-edit-permission`;
export const STORE_REQUISITION_DELETE_PERMISSION = `store-requisition-delete-permission`;
export const STORE_REQUISITION_APPROVE_PERMISSION = `store-requisition-approve-permission`;
export const STORE_REQUISITION_CHECK_PERMISSION = `store-requisition-check-permission`;
export const STORE_REQUISITION_ACKNOWLEDGE_PERMISSION = `store-requisition-acknowledge-permission`;
export const ORGANIZATION_VIEW_PERMISSION = `organization-view-permission`;
export const ORGANIZATION_CREATE_PERMISSION = `organization-create-permission`;
export const ORGANIZATION_EDIT_PERMISSION = `organization-edit-permission`;
export const ORGANIZATION_DELETE_PERMISSION = `organization-delete-permission`;
export const SHIPPING_VIEW_PERMISSION = `shipping-view-permission`;
export const SHIPPING_CREATE_PERMISSION = `shipping-create-permission`;
export const SHIPPING_EDIT_PERMISSION = `shipping-edit-permission`;
export const SHIPPING_DELETE_PERMISSION = `shipping-delete-permission`;
export const BUYER_VIEW_PERMISSION = `buyer-view-permission`;
export const BUYER_CREATE_PERMISSION = `buyer-create-permission`;
export const BUYER_EDIT_PERMISSION = `buyer-edit-permission`;
export const BUYER_DELETE_PERMISSION = `buyer-delete-permission`;
export const BUYING_OFFICE_VIEW_PERMISSION = `buying-office-view-permission`;
export const BUYING_OFFICE_CREATE_PERMISSION = `buying-office-create-permission`;
export const BUYING_OFFICE_EDIT_PERMISSION = `buying-office-edit-permission`;
export const BUYING_OFFICE_DELETE_PERMISSION = `buying-office-delete-permission`;
export const SEWING_LINE_VIEW_PERMISSION = `sewing-line-view-permission`;
export const SEWING_LINE_CREATE_PERMISSION = `sewing-line-create-permission`;
export const SEWING_LINE_EDIT_PERMISSION = `sewing-line-edit-permission`;
export const SEWING_LINE_DELETE_PERMISSION = `sewing-line-delete-permission`;
export const ITEM_VIEW_PERMISSION = `item-view-permission`;
export const ITEM_CREATE_PERMISSION = `item-create-permission`;
export const ITEM_EDIT_PERMISSION = `item-edit-permission`;
export const ITEM_DELETE_PERMISSION = `item-delete-permission`;
export const USER_VIEW_PERMISSION = `user-view-permission`;
export const USER_CREATE_PERMISSION = `user-create-permission`;
export const USER_EDIT_PERMISSION = `user-edit-permission`;
export const USER_DELETE_PERMISSION = `user-delete-permission`;
export const ROLE_VIEW_PERMISSION = `role-view-permission`;
export const ROLE_CREATE_PERMISSION = `role-create-permission`;
export const ROLE_EDIT_PERMISSION = `role-edit-permission`;
export const ROLE_DELETE_PERMISSION = `role-delete-permission`;
export const ITEM_CATEGORY_VIEW_PERMISSION = `item-category-view-permission`;
export const ITEM_CATEGORY_CREATE_PERMISSION = `item-category-create-permission`;
export const ITEM_CATEGORY_EDIT_PERMISSION = `item-category-edit-permission`;
export const ITEM_CATEGORY_DELETE_PERMISSION = `item-category-delete-permission`;
export const STYLE_VIEW_PERMISSION = `style-view-permission`;
export const STYLE_CREATE_PERMISSION = `style-create-permission`;
export const STYLE_EDIT_PERMISSION = `style-edit-permission`;
export const STYLE_DELETE_PERMISSION = `style-delete-permission`;
export const SALES_CONTRACT_VIEW_PERMISSION = `sales-contract-view-permission`;
export const SALES_CONTRACT_CREATE_PERMISSION = `sales-contract-create-permission`;
export const SALES_CONTRACT_EDIT_PERMISSION = `sales-contract-edit-permission`;
export const SALES_CONTRACT_DELETE_PERMISSION = `sales-contract-delete-permission`;
export const SALES_CONTRACT_360_VIEW_PERMISSION = `sales-contract-360-view-permission`;
export const SALES_CONTRACT_360_CREATE_PERMISSION = `sales-contract-360-create-permission`;
export const SALES_CONTRACT_360_EDIT_PERMISSION = `sales-contract-360-edit-permission`;
export const SALES_CONTRACT_360_DELETE_PERMISSION = `sales-contract-360-delete-permission`;
export const PURCHASE_ORDER_VIEW_PERMISSION = `purchase-order-view-permission`;
export const PURCHASE_ORDER_CREATE_PERMISSION = `purchase-order-create-permission`;
export const PURCHASE_ORDER_EDIT_PERMISSION = `purchase-order-edit-permission`;
export const PURCHASE_ORDER_ADD_PRICE_PERMISSION = `purchase-order-add-price-permission`;
export const PURCHASE_ORDER_DELETE_PERMISSION = `purchase-order-delete-permission`;
export const BOM_VIEW_PERMISSION = `bom-view-permission`;
export const BOM_CREATE_PERMISSION = `bom-create-permission`;
export const BOM_EDIT_PERMISSION = `bom-edit-permission`;
export const BOM_DELETE_PERMISSION = `bom-delete-permission`;
export const BOM_EXPORT_PERMISSION = `bom-export-permission`;
export const SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION = `sales-contract-commercial-view-permission`;
export const SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION = `sales-contract-commercial-create-permission`;
export const SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION = `sales-contract-commercial-edit-permission`;
export const SALES_CONTRACT_COMMERCIAL_DELETE_PERMISSION = `sales-contract-commercial-delete-permission`;
export const B2BLC_VIEW_PERMISSION = `b2b-lc-view-permission`;
export const B2BLC_CREATE_PERMISSION = `b2b-lc-create-permission`;
export const B2BLC_EDIT_PERMISSION = `b2b-lc-edit-permission`;
export const B2BLC_DELETE_PERMISSION = `b2b-lc-delete-permission`;
export const PI_VIEW_PERMISSION = `pi-view-permission`;
export const PI_CREATE_PERMISSION = `pi-create-permission`;
export const PI_EDIT_PERMISSION = `pi-edit-permission`;
export const PI_DELETE_PERMISSION = `pi-delete-permission`;
export const PLY_VIEW_PERMISSION = `ply-view-permission`;
export const PLY_CREATE_PERMISSION = `ply-create-permission`;
export const PLY_EDIT_PERMISSION = `ply-edit-permission`;
export const PLY_DELETE_PERMISSION = `ply-delete-permission`;
export const POLY_TYPE_VIEW_PERMISSION = `poly-type-view-permission`;
export const POLY_TYPE_CREATE_PERMISSION = `poly-type-create-permission`;
export const POLY_TYPE_EDIT_PERMISSION = `poly-type-edit-permission`;
export const POLY_TYPE_DELETE_PERMISSION = `poly-type-delete-permission`;
export const PI_BUDGET_VIEW_PERMISSION = `pi-budget-view-permission`;
export const PI_APPROVE_PERMISSION = `pi-approve-permission`;
export const DAILY_IMPORT_POSITION_VIEW_PERMISSION = `daily-import-position-view-permission`;
export const DAILY_IMPORT_POSITION_CREATE_PERMISSION = `daily-import-position-create-permission`;
export const DAILY_IMPORT_POSITION_EDIT_PERMISSION = `daily-import-position-edit-permission`;
export const DAILY_IMPORT_POSITION_DELETE_PERMISSION = `daily-import-position-delete-permission`;
export const IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION = `import-acceptance-detail-view-permission`;
export const IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION = `import-acceptance-detail-create-permission`;
export const IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION = `import-acceptance-detail-edit-permission`;
export const IMPORT_ACCEPTANCE_DETAIL_DELETE_PERMISSION = `import-acceptance-detail-delete-permission`;
export const WAREHOUSE_VIEW_PERMISSION = `warehouse-view-permission`;
export const WAREHOUSE_CREATE_PERMISSION = `warehouse-create-permission`;
export const WAREHOUSE_EDIT_PERMISSION = `warehouse-edit-permission`;
export const WAREHOUSE_DELETE_PERMISSION = `warehouse-delete-permission`;
export const RACK_VIEW_PERMISSION = `rack-view-permission`;
export const RACK_CREATE_PERMISSION = `rack-create-permission`;
export const RACK_EDIT_PERMISSION = `rack-edit-permission`;
export const RACK_DELETE_PERMISSION = `rack-delete-permission`;
export const BIN_VIEW_PERMISSION = `bin-view-permission`;
export const BIN_CREATE_PERMISSION = `bin-create-permission`;
export const BIN_EDIT_PERMISSION = `bin-edit-permission`;
export const BIN_DELETE_PERMISSION = `bin-delete-permission`;

// Carton Booking Configuration Permissions
export const CARTON_WAREHOUSE_VIEW_PERMISSION = `carton-warehouse-view-permission`;
export const CARTON_WAREHOUSE_CREATE_PERMISSION = `carton-warehouse-create-permission`;
export const CARTON_WAREHOUSE_EDIT_PERMISSION = `carton-warehouse-edit-permission`;
export const CARTON_WAREHOUSE_DELETE_PERMISSION = `carton-warehouse-delete-permission`;

export const CARTON_FLOOR_VIEW_PERMISSION = `carton-floor-view-permission`;
export const CARTON_FLOOR_CREATE_PERMISSION = `carton-floor-create-permission`;
export const CARTON_FLOOR_EDIT_PERMISSION = `carton-floor-edit-permission`;
export const CARTON_FLOOR_DELETE_PERMISSION = `carton-floor-delete-permission`;

export const CARTON_PARTITION_VIEW_PERMISSION = `carton-partition-view-permission`;
export const CARTON_PARTITION_CREATE_PERMISSION = `carton-partition-create-permission`;
export const CARTON_PARTITION_EDIT_PERMISSION = `carton-partition-edit-permission`;
export const CARTON_PARTITION_DELETE_PERMISSION = `carton-partition-delete-permission`;

// Fabric Defect Category Permissions
export const FABRIC_DEFECT_CATEGORY_VIEW_PERMISSION = `fabric-defect-category-view-permission`;
export const FABRIC_DEFECT_CATEGORY_CREATE_PERMISSION = `fabric-defect-category-create-permission`;
export const FABRIC_DEFECT_CATEGORY_EDIT_PERMISSION = `fabric-defect-category-edit-permission`;
export const FABRIC_DEFECT_CATEGORY_DELETE_PERMISSION = `fabric-defect-category-delete-permission`;

// Fabric Inspection Permissions
export const FABRIC_INSPECTION_VIEW_PERMISSION = `fabric-inspection-view-permission`;
export const FABRIC_INSPECTION_CREATE_PERMISSION = `fabric-inspection-create-permission`;
export const FABRIC_INSPECTION_EDIT_PERMISSION = `fabric-inspection-edit-permission`;
export const FABRIC_INSPECTION_DELETE_PERMISSION = `fabric-inspection-delete-permission`;

// Final Product Inspection Permissions
export const FINAL_PRODUCT_INSPECTION_VIEW_PERMISSION = `final-product-inspection-view-permission`;
export const FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION = `final-product-inspection-create-permission`;
export const FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION = `final-product-inspection-edit-permission`;
export const FINAL_PRODUCT_INSPECTION_DELETE_PERMISSION = `final-product-inspection-delete-permission`;

export const UNIT_VIEW_PERMISSION = `unit-view-permission`;
export const UNIT_CREATE_PERMISSION = `unit-create-permission`;
export const UNIT_EDIT_PERMISSION = `unit-edit-permission`;
export const UNIT_DELETE_PERMISSION = `unit-delete-permission`;
export const SUPPLIER_VIEW_PERMISSION = `supplier-view-permission`;
export const SUPPLIER_CREATE_PERMISSION = `supplier-create-permission`;
export const SUPPLIER_EDIT_PERMISSION = `supplier-edit-permission`;
export const SUPPLIER_DELETE_PERMISSION = `supplier-delete-permission`;
export const FINISH_GARMENT_VIEW_PERMISSION = `finish-garment-view-permission`;
export const FINISH_GARMENT_CREATE_PERMISSION = `finish-garment-create-permission`;
export const FINISH_GARMENT_EDIT_PERMISSION = `finish-garment-edit-permission`;
export const FINISH_GARMENT_DELETE_PERMISSION = `finish-garment-delete-permission`;
export const CARTON_INVENTORY_VIEW_PERMISSION = `carton-inventory-view-permission`;
export const CARTON_INVENTORY_CREATE_PERMISSION = `carton-inventory-create-permission`;
export const CARTON_INVENTORY_EDIT_PERMISSION = `carton-inventory-edit-permission`;
export const CARTON_INVENTORY_DELETE_PERMISSION = `carton-inventory-delete-permission`;
export const COLOR_VIEW_PERMISSION = `color-view-permission`;
export const COLOR_CREATE_PERMISSION = `color-create-permission`;
export const COLOR_EDIT_PERMISSION = `color-edit-permission`;
export const COLOR_DELETE_PERMISSION = `color-delete-permission`;
export const SIZE_VIEW_PERMISSION = `size-view-permission`;
export const SIZE_CREATE_PERMISSION = `size-create-permission`;
export const SIZE_EDIT_PERMISSION = `size-edit-permission`;
export const SIZE_DELETE_PERMISSION = `size-delete-permission`;
export const EXPORT_DETAILS_VIEW_PERMISSION = `export-details-view-permission`;
export const EXPORT_DETAILS_CREATE_PERMISSION = `export-details-create-permission`;
export const EXPORT_DETAILS_EDIT_PERMISSION = `export-details-edit-permission`;
export const EXPORT_DETAILS_DELETE_PERMISSION = `export-details-delete-permission`;
export const SUBMISSION_REALIZATION_VIEW_PERMISSION = `submission-realization-view-permission`;
export const SUBMISSION_REALIZATION_CREATE_PERMISSION = `submission-realization-create-permission`;
export const SUBMISSION_REALIZATION_EDIT_PERMISSION = `submission-realization-edit-permission`;
export const SUBMISSION_REALIZATION_DELETE_PERMISSION = `submission-realization-delete-permission`;
export const SUPPORTING_MATERIAL_TYPE_VIEW_PERMISSION = `supporting-material-type-view-permission`;
export const SUPPORTING_MATERIAL_TYPE_CREATE_PERMISSION = `supporting-material-type-create-permission`;
export const SUPPORTING_MATERIAL_TYPE_EDIT_PERMISSION = `supporting-material-type-edit-permission`;
export const SUPPORTING_MATERIAL_TYPE_DELETE_PERMISSION = `supporting-material-type-delete-permission`;
export const NOTING_ASSESSMENT_VIEW_PERMISSION = `noting-assessment-detail-view-permission`;
export const NOTING_ASSESSMENT_CREATE_PERMISSION = `noting-assessment-detail-create-permission`;
export const NOTING_ASSESSMENT_EDIT_PERMISSION = `noting-assessment-detail-edit-permission`;
export const NOTING_ASSESSMENT_DELETE_PERMISSION = `noting-assessment-detail-delete-permission`;
export const GOODS_DELIVERY_VIEW_PERMISSION = `goods-delivery-view-permission`;
export const GOODS_DELIVERY_CREATE_PERMISSION = `goods-delivery-create-permission`;
export const GOODS_DELIVERY_EDIT_PERMISSION = `goods-delivery-edit-permission`;
export const GOODS_DELIVERY_DELETE_PERMISSION = `goods-delivery-delete-permission`;
export const IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION = `import-vehicle-assignment-view-permission`;
export const IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION = `import-vehicle-assignment-store-permission`;
export const IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION = `import-vehicle-assignment-edit-permission`;
export const IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION = `import-vehicle-assignment-delete-permission`;
export const EXPORT_SHIPMENT_VIEW_PERMISSION = `export-shipment-view-permission`;
export const EXPORT_SHIPMENT_CREATE_PERMISSION = `export-shipment-create-permission`;
export const EXPORT_SHIPMENT_EDIT_PERMISSION = `export-shipment-edit-permission`;
export const EXPORT_SHIPMENT_DELETE_PERMISSION = `export-shipment-delete-permission`;
export const EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION = `export-vehicle-assignment-view-permission`;
export const EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION = `export-vehicle-assignment-store-permission`;
export const EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION = `export-vehicle-assignment-edit-permission`;
export const EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION = `export-vehicle-assignment-delete-permission`;
export const LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION = `local-outgoing-shipment-view-permission`;
export const LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION = `local-outgoing-shipment-create-permission`;
export const LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION = `local-outgoing-shipment-edit-permission`;
export const LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION = `local-outgoing-shipment-delete-permission`;
export const LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION = `local-incoming-shipment-view-permission`;
export const LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION = `local-incoming-shipment-create-permission`;
export const LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION = `local-incoming-shipment-edit-permission`;
export const LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION = `local-incoming-shipment-delete-permission`;
export const FABRIC_REPORT_VIEW_PERMISSION = `fabric-report-view-permission`;
export const FABRIC_REPORT_CREATE_PERMISSION = `fabric-report-create-permission`;
export const FABRIC_REPORT_EDIT_PERMISSION = `fabric-report-edit-permission`;
export const FABRIC_REPORT_DELETE_PERMISSION = `fabric-report-delete-permission`;
export const FABRIC_REPORT_GENERATE_PERMISSION = `fabric-report-generate-permission`;
export const SWING_VS_FOLDING_REPORT_GENERATE_PERMISSION = `fabric-report-generate-permission`;
export const PRODUCT_TRACK_REPORT_VIEW_PERMISSION = `product-track-report-view-permission`;
export const PRODUCT_TRACK_REPORT_CREATE_PERMISSION = `product-track-report-create-permission`;
export const PRODUCT_TRACK_REPORT_EDIT_PERMISSION = `product-track-report-edit-permission`;
export const PRODUCT_TRACK_REPORT_DELETE_PERMISSION = `product-track-report-delete-permission`;
export const PRODUCT_TRACK_REPORT_GENERATE_PERMISSION = `product-track-report-generate-permission`;
export const PRODUCT_DETAIL_REPORT_GENERATE_PERMISSION = `product-detail-report-generate-permission`;
export const PRODUCT_DETAIL_REPORT_VIEW_PERMISSION = `product-detail-report-view-permission`;
export const PRODUCT_DETAIL_REPORT_CREATE_PERMISSION = `product-detail-report-generate-permission`;
export const PRODUCT_DETAIL_REPORT_EDIT_PERMISSION = `product-detail-report-edit-permission`;
export const PRODUCT_DETAIL_REPORT_DELETE_PERMISSION = `product-detail-report-delete-permission`;
export const COST_SHEET_REPORT_VIEW_PERMISSION = `cost-sheet-report-view-permission`;
export const COST_SHEET_REPORT_GENERATE_PERMISSION = `cost-sheet-report-generate-permission`;
export const COST_SHEET_REPORT_CREATE_PERMISSION = `cost-sheet-report-create-permission`;
export const COST_SHEET_REPORT_EDIT_PERMISSION = `cost-sheet-report-edit-permission`;
export const COST_SHEET_REPORT_DELETE_PERMISSION = `cost-sheet-report-delete-permission`;
export const UPLOAD_BUYER_PERMISSION = `upload-buyer-permission`;
export const UPLOAD_BRAND_PERMISSION = `upload-brand-permission`;
export const UPLOAD_BUYING_OFFICE_PERMISSION = `upload-buying-office-permission`;
export const UPLOAD_BANK_PERMISSION = `upload-bank-permission`;
export const UPLOAD_BRANCH_PERMISSION = `upload-branch-permission`;
export const UPLOAD_MERCHANDISER_PERMISSION = `upload-merchandiser-permission`;
export const UPLOAD_STYLE_PERMISSION = `upload-style-permission`;
export const UPLOAD_SUBSTYLE_PERMISSION = `upload-substyle-permission`;
export const UPLOAD_SALES_CONTRACT_PERMISSION = `upload-sales-contract-permission`;
export const UPLOAD_SUPPLIER_PERMISSION = `upload-supplier-permission`;
export const UPLOAD_COLOR_PERMISSION = `upload-color-permission`;
export const UPLOAD_SIZE_PERMISSION = `upload-size-permission`;
export const UPLOAD_BOM_PERMISSION = `upload-bom-permission`;
export const UPLOAD_PO_PERMISSION = `upload-po-permission`;
export const SECURITY_BOLT_VIEW_PERMISSION = `security-bolt-view-permission`;
export const SECURITY_BOLT_CREATE_PERMISSION = `security-bolt-create-permission`;
export const SECURITY_BOLT_EDIT_PERMISSION = `security-bolt-edit-permission`;
export const SECURITY_BOLT_DELETE_PERMISSION = `security-bolt-delete-permission`;
export const SHIPMENT_HANDOVER_VIEW_PERMISSION = `shipment-handover-view-permission`;
export const SHIPMENT_HANDOVER_CREATE_PERMISSION = `shipment-handover-create-permission`;
export const SHIPMENT_HANDOVER_EDIT_PERMISSION = `shipment-handover-edit-permission`;
export const SHIPMENT_HANDOVER_DELETE_PERMISSION = `shipment-handover-delete-permission`;
export const INVENTORY_DETAIL_REPORT_VIEW_PERMISSION = `inventory-detail-report-view-permission`;
export const INVENTORY_DETAIL_REPORT_GENERATE_PERMISSION = `inventory-detail-report-generate-permission`;
export const INVENTORY_DETAIL_REPORT_DELETE_PERMISSION = `inventory-detail-report-delete-permission`;
export const BUYER_PO_PO_WISE_VIEW_PERMISSION = `po-wise-purchase-order-view-permission`;
export const BUYER_PO_PO_WISE_CREATE_PERMISSION = `po-wise-purchase-order-create-permission`;
export const BUYER_PO_PO_WISE_EDIT_PERMISSION = `po-wise-purchase-order-edit-permission`;
export const BUYER_PO_PO_WISE_DELETE_PERMISSION = `po-wise-purchase-order-delete-permission`;
export const ACTIVITY_LOG_VIEW_PERMISSION = `activity-log-view-permission`;
export const INVENTORY_MRR_REPORT_VIEW_PERMISSION = `inventory-mrr-report-view-permission`;
export const GENERATE_MRR_REPORT_VIEW_PERMISSION = `inventory-mrr-report-generate-permission`;
export const DELETE_MRR_REPORT_VIEW_PERMISSION = `inventory-mrr-report-delete-permission`;
export const OB_MACHINE_VIEW_PERMISSION = `ob-machine-type-view-permission`;
export const OB_MACHINE_CREATE_PERMISSION = `ob-machine-type-create-permission`;
export const OB_MACHINE_EDIT_PERMISSION = `ob-machine-type-edit-permission`;
export const OB_MACHINE_DELETE_PERMISSION = `ob-machine-type-delete-permission`;
export const OB_SECTION_VIEW_PERMISSION = `ob-section-view-permission`;
export const OB_SECTION_CREATE_PERMISSION = `ob-section-create-permission`;
export const OB_SECTION_EDIT_PERMISSION = `ob-section-edit-permission`;
export const OB_SECTION_DELETE_PERMISSION = `ob-section-delete-permission`;
export const OB_SAM_DATA_BANK_VIEW_PERMISSION = `ob-sam-data-bank-view-permission`;
export const OB_SAM_DATA_BANK_CREATE_PERMISSION = `ob-sam-data-bank-create-permission`;
export const OB_SAM_DATA_BANK_EDIT_PERMISSION = `ob-sam-data-bank-edit-permission`;
export const OB_SAM_DATA_BANK_DELETE_PERMISSION = `ob-sam-data-bank-delete-permission`;
export const OB_VIEW_PERMISSION = `operation-bulletin-view-permission`;
export const OB_CREATE_PERMISSION = `operation-bulletin-create-permission`;
export const OB_EDIT_PERMISSION = `operation-bulletin-edit-permission`;
export const OB_DELETE_PERMISSION = `operation-bulletin-delete-permission`;
export const OB_CLONE_PERMISSION = `operation-bulletin-clone-permission`;
export const CHALLAN_CREATE_PERMISSION = `challan-no-create-permission`;
export const CHALLAN_EDIT_PERMISSION = `challan-no-edit-permission`;
export const CHALLAN_VIEW_PERMISSION = `challan-no-view-permission`;
export const CHALLAN_DELETE_PERMISSION = `challan-no-delete-permission`;
export const DAILY_LINE_TARGET_CREATE_PERMISSION = `daily-line-target-create-permission`;
export const DAILY_LINE_TARGET_EDIT_PERMISSION = `daily-line-target-edit-permission`;
export const DAILY_LINE_TARGET_VIEW_PERMISSION = `daily-line-target-view-permission`;
export const DAILY_LINE_TARGET_DELETE_PERMISSION = `daily-line-target-delete-permission`;
export const GARMENT_CATEGORY_VIEW_PERMISSION = `garment-category-view-permission`;
export const GARMENT_CATEGORY_CREATE_PERMISSION = `garment-category-create-permission`;
export const GARMENT_CATEGORY_EDIT_PERMISSION = `garment-category-edit-permission`;
export const GARMENT_CATEGORY_DELETE_PERMISSION = `garment-category-delete-permission`;
export const GARMENT_TYPE_VIEW_PERMISSION = `garment-type-view-permission`;
export const GARMENT_TYPE_CREATE_PERMISSION = `garment-type-create-permission`;
export const GARMENT_TYPE_EDIT_PERMISSION = `garment-type-edit-permission`;
export const GARMENT_TYPE_DELETE_PERMISSION = `garment-type-delete-permission`;
export const AIR_HOLE_TYPE_VIEW_PERMISSION = `air-hole-type-view-permission`;
export const AIR_HOLE_TYPE_CREATE_PERMISSION = `air-hole-type-create-permission`;
export const AIR_HOLE_TYPE_EDIT_PERMISSION = `air-hole-type-edit-permission`;
export const AIR_HOLE_TYPE_DELETE_PERMISSION = `air-hole-type-delete-permission`;
export const AU_FORMULA_VIEW_PERMISSION = `au-formula-view-permission`;
export const AU_FORMULA_CREATE_PERMISSION = `au-formula-create-permission`;
export const AU_FORMULA_EDIT_PERMISSION = `au-formula-edit-permission`;
export const AU_FORMULA_DELETE_PERMISSION = `au-formula-delete-permission`;
export const BUYER_INQUIRY_VIEW_PERMISSION = `buyer-inquiry-view-permission`;
export const BUYER_INQUIRY_CREATE_PERMISSION = `buyer-inquiry-create-permission`;
export const BUYER_INQUIRY_EDIT_PERMISSION = `buyer-inquiry-edit-permission`;
export const BUYER_INQUIRY_DELETE_PERMISSION = `buyer-inquiry-delete-permission`;
export const BUYER_INQUIRY_MULTI_STYLE_CREATE_PERMISSION = `multi-style-create-permission`;
export const CARTON_TYPE_VIEW_PERMISSION = `carton-type-view-permission`;
export const CARTON_TYPE_CREATE_PERMISSION = `carton-type-create-permission`;
export const CARTON_TYPE_EDIT_PERMISSION = `carton-type-edit-permission`;
export const CARTON_TYPE_DELETE_PERMISSION = `carton-type-delete-permission`;
export const GUSSET_TYPE_VIEW_PERMISSION = `gusset-type-view-permission`;
export const GUSSET_TYPE_CREATE_PERMISSION = `gusset-type-create-permission`;
export const GUSSET_TYPE_EDIT_PERMISSION = `gusset-type-edit-permission`;
export const GUSSET_TYPE_DELETE_PERMISSION = `gusset-type-delete-permission`;
export const CAPACITY_BOOKING_VIEW_PERMISSION = `buyer-inquiry-view-permission`;
export const CAPACITY_BOOKING_CREATE_PERMISSION = `buyer-inquiry-create-permission`;
export const CAPACITY_BOOKING_EDIT_PERMISSION = `buyer-inquiry-edit-permission`;
export const CAPACITY_BOOKING_DELETE_PERMISSION = `buyer-inquiry-delete-permission`;
export const COST_OF_MAKING_LIST = `cost-of-making-list`;
export const COST_OF_MAKING_CREATE = `cost-of-making-create`;
export const COST_OF_MAKING_EDIT = `cost-of-making-edit`;
export const COST_OF_MAKING_DELETE = `cost-of-making-delete`;
export const COST_OF_MAKING_DETAILS = `cost-of-making-details-permission`;
export const INQUIRY_REASONS_VIEW_PERMISSION = `inquiry-reasons-view-permission`;
export const INQUIRY_REASONS_CREATE_PERMISSION = `inquiry-reasons-create-permission`;
export const INQUIRY_REASONS_EDIT_PERMISSION = `inquiry-reasons-edit-permission`;
export const INQUIRY_REASONS_DELETE_PERMISSION = `inquiry-reasons-delete-permission`;
export const INQUIRY_REMARKS_VIEW_PERMISSION = `inquiry-remarks-view-permission`;
export const INQUIRY_REMARKS_CREATE_PERMISSION = `inquiry-remarks-create-permission`;
export const INQUIRY_REMARKS_EDIT_PERMISSION = `inquiry-remarks-edit-permission`;
export const INQUIRY_REMARKS_DELETE_PERMISSION = `inquiry-remarks-delete-permission`;
export const LEARNING_CURVE_VIEW_PERMISSION = `learning-curve-view-permission`;
export const LEARNING_CURVE_CREATE_PERMISSION = `learning-curve-create-permission`;
export const LEARNING_CURVE_EDIT_PERMISSION = `learning-curve-edit-permission`;
export const LEARNING_CURVE_CLONE_PERMISSION = `learning-curve-clone-permission`;
export const LEARNING_CURVE_DELETE_PERMISSION = `learning-curve-delete-permission`;
export const OB_TEMPLATE_VIEW_PERMISSION = `ob-template-view-permission`;
export const OB_TEMPLATE_CREATE_PERMISSION = `ob-template-create-permission`;
export const OB_TEMPLATE_EDIT_PERMISSION = `ob-template-edit-permission`;
export const OB_TEMPLATE_DELETE_PERMISSION = `ob-template-delete-permission`;
export const NOTIFICATION_SLUG_VIEW_PERMISSION = `notification-slug-view-permission`;
export const NOTIFICATION_SLUG_CREATE_PERMISSION = `notification-slug-create-permission`;
export const NOTIFICATION_SLUG_EDIT_PERMISSION = `notification-slug-edit-permission`;
export const NOTIFICATION_SLUG_DELETE_PERMISSION = `notification-slug-delete-permission`;
export const NOTIFICATION_SETTING_VIEW_PERMISSION = `notification-setting-view-permission`;
export const NOTIFICATION_SETTING_CREATE_PERMISSION = `notification-setting-create-permission`;
export const NOTIFICATION_SETTING_EDIT_PERMISSION = `notification-setting-edit-permission`;
export const NOTIFICATION_SETTING_DELETE_PERMISSION = `notification-setting-delete-permission`;
export const COST_ESTIMATE_VIEW_PERMISSION = `cost-estimate-view-permission`;
export const COST_ESTIMATE_CREATE_PERMISSION = `cost-estimate-create-permission`;
export const COST_ESTIMATE_EDIT_PERMISSION = `cost-estimate-edit-permission`;
export const COST_ESTIMATE_DELETE_PERMISSION = `cost-estimate-delete-permission`;
export const COST_ESTIMATE_APPROVE_PERMISSION = `cost-estimate-approve-permission`;
export const LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION = `local-purchase-reconciliation-view-permission`;
export const LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION = `local-purchase-reconciliation-create-permission`;
export const LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION = `local-purchase-reconciliation-edit-permission`;
export const LOCAL_PURCHASE_RECONCILIATION_EXPORT_PERMISSION = `local-purchase-reconciliation-export-permission`;
export const LOCAL_PURCHASE_RECONCILIATION_DELETE_PERMISSION = `local-purchase-reconciliation-delete-permission`;
export const PERMISSION_CREATE_PERMISSION = `permission-add-permission`;
export const PERMISSION_EDIT_PERMISSION = `permission-edit-permission`;
export const PERMISSION_DELETE_PERMISSION = `permission-delete-permission`;
export const PERMISSION_VIEW_PERMISSION = `permission-view-permission`;
export const CM_VALUE_APPROVE_PERMISSION = "cm-value-approve-permission";
export const DRIVER_VEHICLE_INFO_VIEW_PERMISSION = `driver-vehicle-info-view-permission`;
export const DRIVER_VEHICLE_INFO_CREATE_PERMISSION = `driver-vehicle-info-create-permission`;
export const DRIVER_VEHICLE_INFO_EDIT_PERMISSION = `driver-vehicle-info-edit-permission`;
export const DRIVER_VEHICLE_INFO_DELETE_PERMISSION = `driver-vehicle-info-delete-permission`;
export const DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION = `driver-vehicle-info-dispatch-time-permission`;
export const BOLT_SEAL_LOG_CREATE_PERMISSION = `bolt-seal-log-create-permission`;
export const BOLT_SEAL_LOG_EDIT_PERMISSION = `bolt-seal-log-edit-permission`;
export const BOLT_SEAL_LOG_VIEW_PERMISSION = `bolt-seal-log-view-permission`;
export const BOLT_SEAL_LOG_DELETE_PERMISSION = `bolt-seal-log-delete-permission`;
export const HOUR_CONFIGURATION_CREATE_PERMISSION = `hour-configuration-create-permission`;

export const TNA_DEPARTMENT_CREATE_PERMISSION = `tna-department-create-permission`;
export const TNA_DEPARTMENT_VIEW_PERMISSION = `tna-department-view-permission`;
export const TNA_DEPARTMENT_EDIT_PERMISSION = `tna-department-edit-permission`;
export const TNA_DEPARTMENT_DELETE_PERMISSION = `tna-department-delete-permission`;

export const TNA_PLAN_CREATE_PERMISSION = `tna-plan-create-permission`;
export const TNA_PLAN_VIEW_PERMISSION = `tna-plan-view-permission`;
export const TNA_PLAN_EDIT_PERMISSION = `tna-plan-edit-permission`;
export const TNA_PLAN_DELETE_PERMISSION = `tna-plan-delete-permission`;

export const TNA_PROCESS_CREATE_PERMISSION = `tna-process-create-permission`;
export const TNA_PROCESS_VIEW_PERMISSION = `tna-process-view-permission`;
export const TNA_PROCESS_EDIT_PERMISSION = `tna-process-edit-permission`;
export const TNA_PROCESS_DELETE_PERMISSION = `tna-process-delete-permission`;

export const TNA_TASK_CREATE_PERMISSION = `tna-task-create-permission`;
export const TNA_TASK_VIEW_PERMISSION = `tna-task-view-permission`;
export const TNA_TASK_EDIT_PERMISSION = `tna-task-edit-permission`;
export const TNA_TASK_DELETE_PERMISSION = `tna-task-delete-permission`;

export const TNA_TEMPLATE_CREATE_PERMISSION = `tna-template-create-permission`;
export const TNA_TEMPLATE_VIEW_PERMISSION = `tna-template-view-permission`;
export const TNA_TEMPLATE_EDIT_PERMISSION = `tna-template-edit-permission`;
export const TNA_TEMPLATE_DELETE_PERMISSION = `tna-template-delete-permission`;

export const TNA_BY_STYLE_CREATE_PERMISSION = `tna-by-style-create-permission`;
export const TNA_BY_STYLE_VIEW_PERMISSION = `tna-by-style-view-permission`;
export const TNA_BY_STYLE_EDIT_PERMISSION = `tna-by-style-edit-permission`;
export const TNA_BY_STYLE_DELETE_PERMISSION = `tna-by-style-delete-permission`;

export const TNA_TO_DO_LIST_VIEW_PERMISSION = `tna-to-do-list-view-permission`;
export const TNA_SUMMARY_VIEW_PERMISSION = `tna-summary-view-permission`;
export const TNA_PLAN_SUMMARY_DETAILS_PERMISSION = `tna-plan-summary-details-permission`;
export const TNA_PLAN_SUMMARY_GRAPH_PERMISSION = `tna-plan-summary-graph-permission`;

export const POST_COSTING_REPORT_GENERATE_PERMISSION = `post-costing-report-generate-permission`;

export const DIGITALIZATION_CHECKLIST_VIEW_PERMISSION = `digitalization-checklist-view-permission`;
export const DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION = `digitalization-absenteeism-view-permission`;
export const DIGITALIZATION_DEFECT_VIEW_PERMISSION = `digitalization-defect-view-permission`;

export const ITEM_OCR_UPLOAD_PERMISSION = `item-ocr-upload-permission`;

export const PP_WEEKEND_VIEW_PERMISSION = `weekend-view-permission`;
export const PP_WEEKEND_CREATE_PERMISSION = `weekend-create-permission`;
export const PP_WEEKEND_EDIT_PERMISSION = `weekend-edit-permission`;
export const PP_WEEKEND_DELETE_PERMISSION = `weekend-delete-permission`;

export const PP_HOLIDAY_VIEW_PERMISSION = `holiday-view-permission`;
export const PP_HOLIDAY_CREATE_PERMISSION = `holiday-create-permission`;
export const PP_HOLIDAY_EDIT_PERMISSION = `holiday-edit-permission`;
export const PP_HOLIDAY_DELETE_PERMISSION = `holiday-delete-permission`;

export const PP_EXCEPTION_VIEW_PERMISSION = `exception-view-permission`;
export const PP_EXCEPTION_CREATE_PERMISSION = `exception-create-permission`;
export const PP_EXCEPTION_EDIT_PERMISSION = `exception-edit-permission`;
export const PP_EXCEPTION_DELETE_PERMISSION = `exception-delete-permission`;

export const PP_PLANNING_REQUEST_VIEW_PERMISSION = `planning-request-view-permission`;
export const PP_PLANNING_REQUEST_CREATE_PERMISSION = `planning-request-create-permission`;
export const PP_PLANNING_REQUEST_EDIT_PERMISSION = `planning-request-edit-permission`;
export const PP_PLANNING_REQUEST_DELETE_PERMISSION = `planning-request-delete-permission`;
export const DAILY_LINE_PLAN_IMPORT_PERMISSION = `daily-line-plan-import-permission`;
export const DIGITALIZATION_ROLE_CHECK_PREMISSION = `digitalization-role-wise-checklists-permission`;

/*  OT Signal  */
export const OT_SIGNAL_CREATE_PERMISSION = `ot-signal-create-permission`;
export const OT_SIGNAL_VIEW_PERMISSION = `ot-signal-view-permission`;
export const OT_SIGNAL_EDIT_PERMISSION = `ot-signal-edit-permission`;
export const OT_SIGNAL_DELETE_PERMISSION = `ot-signal-delete-permission`;

/*  OT Signal Section  */
export const OT_SIGNAL_SECTION_CREATE_PERMISSION = `ot-signal-section-create-permission`;
export const OT_SIGNAL_SECTION_EDIT_PERMISSION = `ot-signal-section-edit-permission`;
export const OT_SIGNAL_SECTION_VIEW_PERMISSION = `ot-signal-section-view-permission`;
export const OT_SIGNAL_SECTION_DELETE_PERMISSION = `ot-signal-section-delete-permission`;

/*  BANK  */
export const BANK_CREATE_PERMISSION = `bank-create-permission`;
export const BANK_EDIT_PERMISSION = `bank-edit-permission`;
export const BANK_VIEW_PERMISSION = `bank-view-permission`;
export const BANK_DELETE_PERMISSION = `bank-delete-permission`;

/*  BRANCH  */
export const BRANCH_CREATE_PERMISSION = `branch-create-permission`;
export const BRANCH_EDIT_PERMISSION = `branch-edit-permission`;
export const BRANCH_VIEW_PERMISSION = `branch-view-permission`;
export const BRANCH_DELETE_PERMISSION = `branch-delete-permission`;

/*  ACCOUNT  */
export const ACCOUNT_CREATE_PERMISSION = `account-create-permission`;
export const ACCOUNT_EDIT_PERMISSION = `account-edit-permission`;
export const ACCOUNT_VIEW_PERMISSION = `account-view-permission`;
export const ACCOUNT_DELETE_PERMISSION = `account-delete-permission`;

// GARMENTS PARTS
export const GARMENTS_PARTS_CREATE_PERMISSION = `garment-part-create-permission`;
export const GARMENTS_PARTS_EDIT_PERMISSION = `garment-part-edit-permission`;
export const GARMENTS_PARTS_VIEW_PERMISSION = `garment-part-view-permission`;
export const GARMENTS_PARTS_DELETE_PERMISSION = `garment-part-delete-permission`;

// ERP USAGE
export const ERP_USAGE_CREATE_PERMISSION = `erp-usage-create-permission`;
export const ERP_USAGE_EDIT_PERMISSION = `erp-usage-edit-permission`;
export const ERP_USAGE_VIEW_PERMISSION = `erp-usage-view-permission`;
export const ERP_USAGE_DELETE_PERMISSION = `erp-usage-delete-permission`;

// ERP USAGE DASHBOARD
export const ERP_USAGE_DASHBOARD_VIEW_PERMISSION = `erp-usage-dashboard-view-permission`;

// ERP USAGE MODULE
export const ERP_USAGE_MODULE_CREATE_PERMISSION = `erp-usage-module-create-permission`;
export const ERP_USAGE_MODULE_EDIT_PERMISSION = `erp-usage-module-edit-permission`;
export const ERP_USAGE_MODULE_VIEW_PERMISSION = `erp-usage-module-view-permission`;
export const ERP_USAGE_MODULE_DELETE_PERMISSION = `erp-usage-module-delete-permission`;

// ERP USAGE MODULE UI
export const ERP_USAGE_MODULE_UI_CREATE_PERMISSION = `erp-usage-module-ui-create-permission`;
export const ERP_USAGE_MODULE_UI_EDIT_PERMISSION = `erp-usage-module-ui-edit-permission`;
export const ERP_USAGE_MODULE_UI_VIEW_PERMISSION = `erp-usage-module-ui-view-permission`;
export const ERP_USAGE_MODULE_UI_DELETE_PERMISSION = `erp-usage-module-ui-delete-permission`;

// ERP USAGE ISSUES
export const ERP_USAGE_ISSUE_CREATE_PERMISSION = `erp-usage-issue-create-permission`;
export const ERP_USAGE_ISSUE_EDIT_PERMISSION = `erp-usage-issue-edit-permission`;
export const ERP_USAGE_ISSUE_VIEW_PERMISSION = `erp-usage-issue-view-permission`;
export const ERP_USAGE_ISSUE_DELETE_PERMISSION = `erp-usage-issue-delete-permission`;

// PRODUCTION PLANNING
export const PLAN_CREATE_PERMISSION = `plan-entry-create-permission`;
export const PLAN_EDIT_PERMISSION = `plan-entry-edit-permission`;
export const PLAN_VIEW_PERMISSION = `plan-entry-view-permission`;
export const PLAN_DELETE_PERMISSION = `plan-entry-delete-permission`;
export const PLAN_DASHBOARD_VIEW_PERMISSION = `plan-dashboard-view-permission`;

export const CGL_AUDIT_VIEW_PERMISSION = `cgl-audit-view-permission`;
export const CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION = `cgl-audit-report-list-view-permission`;

export const CAPACITY_BOOKING_MENU_VIEW_PERMISSION = `buyer-inquiry-menu-view-permission`;
export const BUYER_WISE_CHECKLIST_VIEW_PERMISSION = `buyerwise-checklist-view-permission`;
export const CHECKLIST_MENU_VIEW_PERMISSION = `checklist-menu-view-permission`;
export const PP_BUYER_INSPECTION_MENU_VIEW_PERMISSION = `pp-buyer-inspection-menu-view-permission`;
export const DIGITALIZATION_SETTINGS_VIEW_PERMISSION = `digitalization-settings-view-permission`;
export const DAILY_LINE_PLAN_VIEW_PERMISSION = `daily-line-plan-view-permission`;
export const DAILY_LINE_PLAN_DELETE_PERMISSION = `daily-line-plan-delete-permission`;
export const GARMENTS_TRACKING_VIEW_PERMISSION = `garments-tracking-view-permission`;
export const HOURLY_PRODUCTION_VIEW_PERMISSION = `hourly-production-view-permission`;
export const SUPERVISOR_CHECKLIST_CREATE_PERMISSION = `supervisor-checklist-create-permission`;
export const SUPERVISOR_CHECKLIST_EDIT_PERMISSION = `supervisor-checklist-edit-permission`;
export const SUPERVISOR_CHECKLIST_VIEW_PERMISSION = `supervisor-checklist-view-permission`;
export const SUPERVISOR_CHECKLIST_DELETE_PERMISSION = `supervisor-checklist-delete-permission`;
export const APP_DASHBOARD_VIEW_PERMISSION = `app-dashboard-view-permission`;
export const DIGITALIZATION_MENU_VIEW_PERMISSION = `digitalization-menu-view-permission`;
export const WASHING_SNAP_BUTTON_VIEW_PERMISSION = `washing-snap-button-view-permission`;
export const EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION = `embroidery-printing-smocking-pintuck-view-permission`;
export const FABRIC_ACCESSORIES_AUTO_RECONCILIATION_VIEW_PERMISSION = `fabric-accessories-auto-reconciliation-view-permission`;
export const SUBCONTRACT_FACTORY_VIEW_PERMISSION = `subcontract-factory-view-permission`;
export const OB_TEMPLATE_IMPORT_PERMISSION = `ob-template-import-permission`;
export const BOLT_SEAL_LOG_REPORT_PERMISSION = `bolt-seal-log-report-permission`;
export const OSR_REPORT_GENERATE_PERMISSION = `osr-report-generate-permission`;
export const SEWING_FOLDING_REPORT_GENERATE_PERMISSION = `sewing-folding-report-generate-permission`;
export const ABSINTHIUM_REPORT_GENERATE_PERMISSION = `absinthium-report-generate-permission`;
export const ABSENTEEISM_INFORMED_REASON_REPORT_GENERATE_PERMISSION = `absenteeism-informed-reason-report-generate-permission`;
export const PACKING_LIST_REPORT_VIEW_PERMISSION = `packing-list-report-view-permission`;
export const OB_REPORT_PERMISSION = `ob-report-permission`;
export const HR_OT_EXPENSE_DATA_IMPORT_PERMISSION = `hr-ot-expense-data-import-permission`;
export const DAILY_SEWING_PERFORMANCE_VIEW_PERMISSION = `daily-sewing-performance-view-permission`;
export const PNL_REPORT_VIEW_PERMISSION = `pnl-report-view-permission`;
export const VIEW_ALL_ACTIVE_POS_PERMISSION = `view-all-active-pos`;
export const IPR_REPORT_VIEW_PERMISSION = `ipr-report-view-permission`;
export const LINE_WISE_SEWING_REPORT_VIEW_PERMISSION = `line-wise-sewing-report-view-permission`;
export const INITIAL_SAM_MENU_PERMISSION = `initial-sam-menu-permission`;
export const INITIAL_SAM_STORE_PERMISSION = `initial-sam-store-permission`;
export const INITIAL_SAM_APPROVAL_PERMISSION = `initial-sam-approval-permission`;

// Import Invoice Expense Permission

export const IMPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION = `import-invoice-expense-tracker-view-permission`;
export const IMPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION = `import-invoice-expense-tracker-edit-permission`;
export const IMPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION = `import-invoice-expense-tracker-create-permission`;
export const IMPORT_INVOICE_EXPENSE_TRACKER_DELETE_PERMISSION = `import-invoice-expense-tracker-delete-permission`;

// Import LC Expense Permission

export const IMPORT_LC_EXPENSE_TRACKER_VIEW_PERMISSION = `import-lc-expense-tracker-view-permission`;
export const IMPORT_LC_EXPENSE_TRACKER_EDIT_PERMISSION = `import-lc-expense-tracker-edit-permission`;
export const IMPORT_LC_EXPENSE_TRACKER_CREATE_PERMISSION = `import-lc-expense-tracker-create-permission`;
export const IMPORT_LC_EXPENSE_TRACKER_DELETE_PERMISSION = `import-lc-expense-tracker-delete-permission`;

// Export Invoice Expense Permission

export const EXPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION = `export-invoice-expense-tracker-view-permission`;
export const EXPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION = `export-invoice-expense-tracker-edit-permission`;
export const EXPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION = `export-invoice-expense-tracker-create-permission`;
export const EXPORT_INVOICE_EXPENSE_TRACKER_DELETE_PERMISSION = `export-invoice-expense-tracker-delete-permission`;

// Export Sales Contract Expense Permission

export const EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_VIEW_PERMISSION = `export-sales-contract-expense-tracker-view-permission`;
export const EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_EDIT_PERMISSION = `export-sales-contract-expense-tracker-edit-permission`;
export const EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_CREATE_PERMISSION = `export-sales-contract-expense-tracker-create-permission`;
export const EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_DELETE_PERMISSION = `export-sales-contract-expense-tracker-delete-permission`;
// import-export-expense-tracking
export const IMPORT_EXPORT_EXPENSE_TRACKING_VIEW_PERMISSION = `import-export-expense-tracking-view-permission`;

export const COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION = `commercial-packing-requirement-view-permission`;
export const COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION = `commercial-packing-requirement-edit-permission`;
export const APP_OFFLINE_SYNC_LOG_VIEW_PERMISSION = `app-offline-sync-log-view-permission`;

export const PROBLEM_REMEDY_MAP_VIEW_PERMISSION = `problem-remedy-remedy-map-view-permission`;
export const PROBLEM_REMEDY_MAP_CREATE_PERMISSION = `problem-remedy-remedy-map-create-permission`;
export const PROBLEM_REMEDY_MAP_EDIT_PERMISSION = `problem-remedy-remedy-map-edit-permission`;
export const PROBLEM_REMEDY_MAP_DELETE_PERMISSION = `problem-remedy-remedy-map-delete-permission`;

export const PROBLEM_REMEDY_LOG_VIEW_PERMISSION = `problem-remedy-remedy-log-view-permission`;

export const LINE_WISE_CATEGORY_DEFECT_REPORT_VIEW_PERMISSION = `dhu-line-wise-caegory-defect-report-view-permission`;

export const SEWING_LINE_DEFECT_REPORT_VIEW_PERMISSION = `sewing-line-defect-report-view-permission`;
export const SEWING_LINE_DEFECT_MONTHLY_REPORT_VIEW_PERMISSION = `sewing-line-defect-monthly-report-view-permission`;

export const QC_VALIDATION_REPORT_VIEW_PERMISSION = `qc-validation-report-view-permission`;

export const ITEM_TYPE_VIEW_PERMISSION = `itemtype-view-permission`;
export const ITEM_TYPE_CREATE_PERMISSION = `itemtype-create-permission`;
export const ITEM_TYPE_EDIT_PERMISSION = `itemtype-edit-permission`;
export const ITEM_TYPE_DELETE_PERMISSION = `itemtype-delete-permission`;

export const STOCK_LOT_VIEW_PERMISSION = `stock-lot-view-permission`;
export const STOCK_LOT_CREATE_PERMISSION = `stock-lot-create-permission`;
export const STOCK_LOT_EDIT_PERMISSION = `stock-lot-edit-permission`;
export const STOCK_LOT_DELETE_PERMISSION = `stock-lot-delete-permission`;

export const FINISHING_LINE_VIEW_PERMISSION = `finishing-line-view-permission`;
export const FINISHING_LINE_CREATE_PERMISSION = `finishing-line-create-permission`;
export const FINISHING_LINE_EDIT_PERMISSION = `finishing-line-edit-permission`;
export const FINISHING_LINE_DELETE_PERMISSION = `finishing-line-delete-permission`;
export const FINISHING_LINE_MAPPING_VIEW_PERMISSION = `finishing-line-mapping-view-permission`;
export const FINISHING_LINE_MAPPING_CREATE_PERMISSION = `finishing-line-mapping-create-permission`;

export const GARMENT_RECEIVED_CREATE_PERMISSION = `garment-received-create-permission`;
export const GARMENT_RECEIVED_VIEW_PERMISSION = `garment-received-view-permission`;
export const GARMENT_RECEIVED_UPDATE_PERMISSION = `garment-received-update-permission`;

export const HOURLY_IRON_VIEW_PERMISSION = `hourly-iron-view-permission`;
export const HOURLY_IRON_CREATE_PERMISSION = `hourly-iron-create-permission`;
export const HOURLY_IRON_EDIT_PERMISSION = `hourly-iron-edit-permission`;
export const HOURLY_FOLD_CREATE_PERMISSION = `hourly-fold-create-permission`;
export const HOURLY_FOLD_VIEW_PERMISSION = `hourly-fold-view-permission`;
export const HOURLY_FOLD_EDIT_PERMISSION = `hourly-fold-edit-permission`;
export const HOURLY_POLY_CREATE_PERMISSION = `hourly-poly-create-permission`;
export const HOURLY_POLY_VIEW_PERMISSION = `hourly-poly-view-permission`;
export const HOURLY_POLY_EDIT_PERMISSION = `hourly-poly-edit-permission`;

export const FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION = `finishing-garment-received-create-permission`;
export const FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION = `finishing-garment-received-view-permission`;
export const FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION = `finishing-garment-received-update-permission`;

export const ITEM_TYPES_VIEW_PERMISSION = `itemtype-view-permission`;
export const ITEM_TYPES_CREATE_PERMISSION = `itemtype-create-permission`;
export const ITEM_TYPES_EDIT_PERMISSION = `itemtype-edit-permission`;
export const ITEM_TYPES_DELETE_PERMISSION = `itemtype-delete-permission`;

export const MACHINE_INFORMATION_VIEW_PERMISSION = `machine-information-view-permission`;
export const MACHINE_INFORMATION_STORE_PERMISSION = `machine-information-store-permission`;
export const MACHINE_INFORMATION_UPDATE_PERMISSION = `machine-information-update-permission`;
export const MACHINE_INFORMATION_DELETE_PERMISSION = `machine-information-delete-permission`;
export const MACHINE_INFORMATION_IMPORT_PERMISSION = `machine-information-import-permission`;

export const MACHINE_BRAND_VIEW_PERMISSION = `machine-brand-view-permission`;
export const MACHINE_BRAND_STORE_PERMISSION = `machine-brand-store-permission`;
export const MACHINE_BRAND_UPDATE_PERMISSION = `machine-brand-update-permission`;
export const MACHINE_BRAND_DELETE_PERMISSION = `machine-brand-delete-permission`;

export const MACHINE_COMPANY_VIEW_PERMISSION = `machine-company-view-permission`;
export const MACHINE_COMPANY_STORE_PERMISSION = `machine-company-store-permission`;
export const MACHINE_COMPANY_UPDATE_PERMISSION = `machine-company-update-permission`;
export const MACHINE_COMPANY_DELETE_PERMISSION = `machine-company-delete-permission`;

export const MACHINE_MODEL_VIEW_PERMISSION = `machine-model-view-permission`;
export const MACHINE_MODEL_STORE_PERMISSION = `machine-model-store-permission`;
export const MACHINE_MODEL_UPDATE_PERMISSION = `machine-model-update-permission`;
export const MACHINE_MODEL_DELETE_PERMISSION = `machine-model-delete-permission`;

export const MACHINE_LOCATION_VIEW_PERMISSION = `machine-location-view-permission`;
export const MACHINE_LOCATION_STORE_PERMISSION = `machine-location-store-permission`;
export const MACHINE_LOCATION_UPDATE_PERMISSION = `machine-location-update-permission`;
export const MACHINE_LOCATION_DELETE_PERMISSION = `machine-location-delete-permission`;

export const MACHINE_MACHINE_LINE_VIEW_PERMISSION = `machine-line-view-permission`;
export const MACHINE_MACHINE_LINE_STORE_PERMISSION = `machine-line-store-permission`;
export const MACHINE_MACHINE_LINE_UPDATE_PERMISSION = `machine-line-update-permission`;
export const MACHINE_MACHINE_LINE_DELETE_PERMISSION = `machine-line-delete-permission`;

export const MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION = `machine-origin-country-view-permission`;
export const MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION = `machine-origin-country-store-permission`;
export const MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION = `machine-origin-country-update-permission`;
export const MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION = `machine-origin-country-delete-permission`;

export const MACHINE_ACTION_TYPE_VIEW_PERMISSION = `machine-action-type-view-permission`;
export const MACHINE_ACTION_TYPE_STORE_PERMISSION = `machine-action-type-store-permission`;
export const MACHINE_ACTION_TYPE_UPDATE_PERMISSION = `machine-action-type-update-permission`;
export const MACHINE_ACTION_TYPE_DELETE_PERMISSION = `machine-action-type-delete-permission`;

export const MACHINE_FAULT_TYPE_VIEW_PERMISSION = `machine-fault-type-view-permission`;
export const MACHINE_FAULT_TYPE_STORE_PERMISSION = `machine-fault-type-store-permission`;
export const MACHINE_FAULT_TYPE_UPDATE_PERMISSION = `machine-fault-type-update-permission`;
export const MACHINE_FAULT_TYPE_DELETE_PERMISSION = `machine-fault-type-delete-permission`;

export const MACHINE_LINE_ATTENDANCE_MECHANIC_LIST_PERMISSION = `machine-line-attendance-mechanic-list-permission`;

export const MACHINE_LINE_ISSUES_VIEW_PERMISSION = `machine-issue-view-permission`;

export const SALES_CONTRACT_AMENDMENT_LIEN_COST_DELETE_PERMISSION = `sales-contract-amendment-lien-cost-delete-permission`;
export const SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION = `sales-contract-amendment-lien-cost-view-permission`;
export const SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION = `sales-contract-amendment-lien-cost-edit-permission`;
export const SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION = `sales-contract-amendment-lien-cost-create-permission`;

export const SALES_CONTRACT_LIEN_COST_DELETE_PERMISSION = `sales-contract-lien-cost-delete-permission`;
export const SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION = `sales-contract-lien-cost-view-permission`;
export const SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION = `sales-contract-lien-cost-edit-permission`;
export const SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION = `sales-contract-lien-cost-create-permission`;

export const EB_COLLECTION_CHARGE_VIEW_PERMISSION = `eb-collection-charge-view-permission`;
export const EB_COLLECTION_CHARGE_CREATE_PERMISSION = `eb-collection-charge-create-permission`;
export const EB_COLLECTION_CHARGE_EDIT_PERMISSION = `eb-collection-charge-edit-permission`;
export const EB_COLLECTION_CHARGE_DELETE_PERMISSION = `eb-collection-charge-delete-permission`;
export const EB_COLLECTION_CHARGE_PRINT_PERMISSION = `eb-collection-charge-print-permission`;

// Export Documentation Fee permissions
export const EXPORT_DOC_FEE_DELETE_PERMISSION = `export-doc-fee-delete-permission`;
export const EXPORT_DOC_FEE_VIEW_PERMISSION = `export-doc-fee-view-permission`;
export const EXPORT_DOC_FEE_EDIT_PERMISSION = `export-doc-fee-edit-permission`;
export const EXPORT_DOC_FEE_CREATE_PERMISSION = `export-doc-fee-create-permission`;

// Certificate of Origin Fee permissions
export const CERTIFICATE_OF_ORIGIN_FEE_DELETE_PERMISSION = `certificate-of-origin-fee-delete-permission`;
export const CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION = `certificate-of-origin-fee-view-permission`;
export const CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION = `certificate-of-origin-fee-edit-permission`;
export const CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION = `certificate-of-origin-fee-create-permission`;

// EPB Type permissions
export const EPB_TYPE_DELETE_PERMISSION = `epb-type-delete-permission`;
export const EPB_TYPE_VIEW_PERMISSION = `epb-type-view-permission`;
export const EPB_TYPE_EDIT_PERMISSION = `epb-type-edit-permission`;
export const EPB_TYPE_CREATE_PERMISSION = `epb-type-create-permission`;

// EPB Attribute permissions
export const EPB_ATTRIBUTE_DELETE_PERMISSION = `epb-attribute-delete-permission`;
export const EPB_ATTRIBUTE_VIEW_PERMISSION = `epb-attribute-view-permission`;
export const EPB_ATTRIBUTE_EDIT_PERMISSION = `epb-attribute-edit-permission`;
export const EPB_ATTRIBUTE_CREATE_PERMISSION = `epb-attribute-create-permission`;

// IOU Cost permissions
export const SALES_CONTRACT_IOU_COST_DELETE_PERMISSION = `sales-contract-iou-cost-delete-permission`;
export const SALES_CONTRACT_IOU_COST_VIEW_PERMISSION = `sales-contract-iou-cost-view-permission`;
export const SALES_CONTRACT_IOU_COST_EDIT_PERMISSION = `sales-contract-iou-cost-edit-permission`;
export const SALES_CONTRACT_IOU_COST_CREATE_PERMISSION = `sales-contract-iou-cost-create-permission`;

export const EXIM_CONFIGURE_DELETE_PERMISSION = `exim-configure-delete-permission`;
export const EXIM_CONFIGURE_VIEW_PERMISSION = `exim-configure-view-permission`;
export const EXIM_CONFIGURE_EDIT_PERMISSION = `exim-configure-edit-permission`;
export const EXIM_CONFIGURE_CREATE_PERMISSION = `exim-configure-create-permission`;

// External C&F Bills permissions
export const EXTERNAL_CNF_BILLS_DELETE_PERMISSION = `external-cnf-bills-delete-permission`;
export const EXTERNAL_CNF_BILLS_VIEW_PERMISSION = `external-cnf-bills-view-permission`;
export const EXTERNAL_CNF_BILLS_EDIT_PERMISSION = `external-cnf-bills-edit-permission`;
export const EXTERNAL_CNF_BILLS_CREATE_PERMISSION = `external-cnf-bills-create-permission`;

export const BGMEA_UD_COST_DELETE_PERMISSION = `bgmea-ud-cost-delete-permission`;
export const BGMEA_UD_COST_VIEW_PERMISSION = `bgmea-ud-cost-view-permission`;
export const BGMEA_UD_COST_EDIT_PERMISSION = `bgmea-ud-cost-edit-permission`;
export const BGMEA_UD_COST_CREATE_PERMISSION = `bgmea-ud-cost-create-permission`;

export const BGMEA_UD_AMENDMENT_DELETE_PERMISSION = `bgmea-ud-amendment-delete-permission`;
export const BGMEA_UD_AMENDMENT_VIEW_PERMISSION = `bgmea-ud-amendment-view-permission`;
export const BGMEA_UD_AMENDMENT_EDIT_PERMISSION = `bgmea-ud-amendment-edit-permission`;
export const BGMEA_UD_AMENDMENT_CREATE_PERMISSION = `bgmea-ud-amendment-create-permission`;

export const BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_PERMISSION = `bgmea-ud-export-permission-cost-delete-permission`;
export const BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION = `bgmea-ud-export-permission-cost-view-permission`;
export const BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION = `bgmea-ud-export-permission-cost-edit-permission`;
export const BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION = `bgmea-ud-export-permission-cost-create-permission`;

// B2B_LC_OPOENING_COST
export const B2B_LC_OPENING_COST_DELETE_PERMISSION = `b2b-lc-opening-cost-delete-permission`;
export const B2B_LC_OPENING_COST_VIEW_PERMISSION = `b2b-lc-opening-cost-view-permission`;
export const B2B_LC_OPENING_COST_EDIT_PERMISSION = `b2b-lc-opening-cost-edit-permission`;
export const B2B_LC_OPENING_COST_CREATE_PERMISSION = `b2b-lc-opening-cost-create-permission`;

// B2B LC Amendment Opening Cost Permissions
export const B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION = `b2b-lc-amendment-opening-cost-view-permission`;
export const B2B_LC_AMENDMENT_OPENING_COST_CREATE_PERMISSION = `b2b-lc-amendment-opening-cost-create-permission`;
export const B2B_LC_AMENDMENT_OPENING_COST_EDIT_PERMISSION = `b2b-lc-amendment-opening-cost-edit-permission`;
export const B2B_LC_AMENDMENT_OPENING_COST_DELETE_PERMISSION = `b2b-lc-amendment-opening-cost-delete-permission`;

// B2B LC Shipping Guarantee Cost Permissions
export const B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION = `b2b-lc-shipping-guarantee-cost-view-permission`;
export const B2B_LC_SHIPPING_GUARANTEE_COST_CREATE_PERMISSION = `b2b-lc-shipping-guarantee-cost-create-permission`;
export const B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_PERMISSION = `b2b-lc-shipping-guarantee-cost-edit-permission`;
export const B2B_LC_SHIPPING_GUARANTEE_COST_DELETE_PERMISSION = `b2b-lc-shipping-guarantee-cost-delete-permission`;

// B2B LC Acceptance Commission Permissions
export const B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION = `b2b-lc-acceptance-commission-view-permission`;
export const B2B_LC_ACCEPTANCE_COMMISSION_CREATE_PERMISSION = `b2b-lc-acceptance-commission-create-permission`;
export const B2B_LC_ACCEPTANCE_COMMISSION_EDIT_PERMISSION = `b2b-lc-acceptance-commission-edit-permission`;
export const B2B_LC_ACCEPTANCE_COMMISSION_DELETE_PERMISSION = `b2b-lc-acceptance-commission-delete-permission`;

export const LOCAL_INVOICE_CREATE_PERMISSION = `local-invoice-create-permission`;
export const LOCAL_INVOICE_DOC_SEND_RECEIVE_DATA_PERMISSION = `local-invoice-doc-send-receive-data-permission`;
export const IMPORT_MENU_VIEW_PERMISSION = `import-menu-view-permission`;

// Import Bill Retirement Permission
export const IMPORT_BILL_RETIREMENT_VIEW_PERMISSION = `import-bill-retirement-view-permission`;
export const IMPORT_BILL_RETIREMENT_CREATE_PERMISSION = `import-bill-retirement-create-permission`;
export const IMPORT_BILL_RETIREMENT_EDIT_PERMISSION = `import-bill-retirement-edit-permission`;
export const IMPORT_BILL_RETIREMENT_DELETE_PERMISSION = `import-bill-retirement-delete-permission`;

// Marine Cover Note Bill Permission
export const MARINA_COVER_NOTE_BILL_VIEW_PERMISSION = `marine-cover-note-bill-view-permission`;
export const MARINA_COVER_NOTE_BILL_CREATE_PERMISSION = `marine-cover-note-bill-create-permission`;
export const MARINA_COVER_NOTE_BILL_EDIT_PERMISSION = `marine-cover-note-bill-edit-permission`;
export const MARINA_COVER_NOTE_BILL_DELETE_PERMISSION = `marine-cover-note-bill-delete-permission`;

export const FOLDING_REQUIREMENT_DELETE_PERMISSION = `folding-requirement-delete-permission`;
export const FOLDING_REQUIREMENT_VIEW_PERMISSION = `folding-requirement-view-permission`;
export const FOLDING_REQUIREMENT_CREATE_PERMISSION = `folding-requirement-create-permission`;
export const FOLDING_REQUIREMENT_EDIT_PERMISSION = `folding-requirement-edit-permission`;

// Packing report template permission
export const PACKING_REPORT_TEMPLATE_VIEW_PERMISSION = `packing-report-template-view-permission`;
export const PACKING_REPORT_TEMPLATE_STORE_PERMISSION = `packing-report-template-store-permission`;
export const PACKING_REPORT_TEMPLATE_UPDATE_PERMISSION = `packing-report-template-update-permission`;
export const PACKING_REPORT_TEMPLATE_DELETE_PERMISSION = `packing-report-template-delete-permission`;
export const PACKING_REPORT_TEMPLATE_EXPORT_PERMISSION = `packing-report-template-export-permission`;
export const IOU_DELETE_PERMISSION = `iou-delete-permission`;
export const IOU_EDIT_PERMISSION = `iou-edit-permission`;
export const IOU_CREATE_PERMISSION = `iou-create-permission`;
export const IOU_VIEW_PERMISSION = `iou-view-permission`;

export const IOU_DISBURSE_PERMISSION = `iou-disburse-permission`;

export const SUPPLIER_WISE_ITEM_PRICE_REPORT_VIEW_PERMISSION = `supplier-wise-item-price-report-view-permission`;
export const SALES_CONTRACT_COSTING_REPORT = `sales-contact-costing-report`;

export const IOU_EXPENDITURE_FOR_EXPORT = `iou-Expenditure-for-export`;
export const IOU_EXPENDITURE_FOR_IMPORT = `iou-Expenditure-for-import`;
export const IOU_EXPENDITURE_FOR_AIR = `iou-Expenditure-for-air`;

// IOU Adjustment Import — manage via Permission Master
export const IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION = `iou-adjustment-import-view-permission`;
export const IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION = `iou-adjustment-import-create-permission`;
export const IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION = `iou-adjustment-import-edit-permission`;
export const IOU_ADJUSTMENT_IMPORT_DELETE_PERMISSION = `iou-adjustment-import-delete-permission`;
export const IOU_ADJUSTMENT_IMPORT_APPROVE_PERMISSION = `iou-adjustment-import-approve-permission`;

// IOU Adjustment Export — manage via Permission Master
export const IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION = `iou-adjustment-export-view-permission`;
export const IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION = `iou-adjustment-export-create-permission`;
export const IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION = `iou-adjustment-export-edit-permission`;
export const IOU_ADJUSTMENT_EXPORT_DELETE_PERMISSION = `iou-adjustment-export-delete-permission`;
export const IOU_ADJUSTMENT_EXPORT_APPROVE_PERMISSION = `iou-adjustment-export-approve-permission`;

export const IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION = `iou-adjustment-general-view-permission`;
export const IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION = `iou-adjustment-general-create-permission`;
export const IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION = `iou-adjustment-general-edit-permission`;
export const IOU_ADJUSTMENT_GENERAL_DELETE_PERMISSION = `iou-adjustment-general-delete-permission`;
export const IOU_ADJUSTMENT_GENERAL_APPROVE_PERMISSION = `iou-adjustment-general-approve-permission`;

export const PI_REPORT_VIEW_PERMISSION = `pi-report-view-permission`;
export const PACKING_LINE_VIEW_PERMISSION = `packing-line-view-permission`;
export const PACKING_LINE_CREATE_PERMISSION = `packing-line-create-permission`;
export const PACKING_LINE_EDIT_PERMISSION = `packing-line-edit-permission`;
export const PACKING_LINE_DELETE_PERMISSION = `packing-line-delete-permission`;

export const PACKING_TABLE_VIEW_PERMISSION = `packing-table-view-permission`;
export const PACKING_TABLE_CREATE_PERMISSION = `packing-table-create-permission`;
export const PACKING_TABLE_EDIT_PERMISSION = `packing-table-edit-permission`;
export const PACKING_TABLE_DELETE_PERMISSION = `packing-table-delete-permission`;

export const PACKING_OPERATOR_MAPPING_VIEW_PERMISSION = `packing-operator-mapping-view-permission`;
export const PACKING_OPERATOR_MAPPING_CREATE_PERMISSION = `packing-operator-mapping-create-permission`;
export const PACKING_OPERATOR_MAPPING_EDIT_PERMISSION = `packing-operator-mapping-edit-permission`;
export const PACKING_OPERATOR_MAPPING_DELETE_PERMISSION = `packing-operator-mapping-delete-permission`;

export const HOURLY_PACKING_VIEW_PERMISSION = `hourly-packing-view-permission`;
export const HOURLY_PACKING_CREATE_PERMISSION = `hourly-packing-create-permission`;
export const HOURLY_PACKING_EDIT_PERMISSION = `hourly-packing-edit-permission`;
export const HOURLY_PACKING_DELETE_PERMISSION = `hourly-packing-delete-permission`;

export const DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION = `daily-packing-assignment-view-permission`;
export const DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION = `daily-packing-assignment-create-permission`;
export const DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION = `daily-packing-assignment-edit-permission`;
export const DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION = `daily-packing-assignment-delete-permission`;

export const HOURLY_OPERATION_TRACKING_CREATE_PERMISSION = `hourly-operation-tracking-create`;
export const HOURLY_OPERATION_TRACKING_EDIT_PERMISSION = `hourly-operation-tracking-edit`;
export const HOURLY_OPERATION_TRACKING_VIEW_PERMISSION = `hourly-operation-tracking-view`;
export const HOURLY_OPERATION_TRACKING_DELETE_PERMISSION = `hourly-operation-tracking-delete`;

// Booking QTY
export const BOOKING_QTY_VIEW_PERMISSION = `booking-qty-view-permission`;
export const BOOKING_QTY_CREATE_PERMISSION = `booking-qty-create-permission`;
export const BOOKING_QTY_EDIT_PERMISSION = `booking-qty-edit-permission`;
export const BOOKING_QTY_DELETE_PERMISSION = `booking-qty-delete-permission`;

// Transportation Cost
export const TRANSPORTATION_COST_VIEW_PERMISSION = `transportation-cost-view-permission`;
export const TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION = `transportation-cost-config-view-permission`;
export const TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION = `transportation-cost-config-create-permission`;
export const TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION = `transportation-cost-config-edit-permission`;
export const TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION = `transportation-cost-config-delete-permission`;
export const TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION = `transportation-cost-entry-view-permission`;
export const TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION = `transportation-cost-entry-create-permission`;
export const TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION = `transportation-cost-entry-edit-permission`;
export const TRANSPORTATION_COST_ENTRY_DELETE_PERMISSION = `transportation-cost-entry-delete-permission`;
export const TRANSPORTATION_COST_ENTRY_PRINT_PERMISSION = `transportation-cost-entry-print-permission`;

// Production Planning List
export const PRODUCTION_PLANNING_LIST_VIEW_PERMISSION = `production-planning-list-view-permission`;

// Capacity Booking Report (Production Planning)
export const CAPACITY_BOOKING_REPORT_VIEW_PERMISSION = `capacity-booking-report-view-permission`;

// Carton & Poly Booking
export const BOOKING_CARTON_VIEW_PERMISSION = `booking-carton-view-permission`;
export const BOOKING_CARTON_CREATE_PERMISSION = `booking-carton-create-permission`;
export const BOOKING_CARTON_EDIT_PERMISSION = `booking-carton-edit-permission`;
export const BOOKING_CARTON_DELETE_PERMISSION = `booking-carton-delete-permission`;

// Sample Requisition (Merchandising)
export const SAMPLE_REQUISITION_VIEW_PERMISSION = `sample-requisition-view-permission`;
export const SAMPLE_REQUISITION_CREATE_PERMISSION = `sample-requisition-create-permission`;
export const SAMPLE_REQUISITION_EDIT_PERMISSION = `sample-requisition-edit-permission`;
export const SAMPLE_REQUISITION_DELETE_PERMISSION = `sample-requisition-delete-permission`;

// Sample Type (Merchandising master config)
export const SAMPLE_TYPE_VIEW_PERMISSION = `sample-type-view-permission`;
export const SAMPLE_TYPE_CREATE_PERMISSION = `sample-type-create-permission`;
export const SAMPLE_TYPE_EDIT_PERMISSION = `sample-type-edit-permission`;
export const SAMPLE_TYPE_DELETE_PERMISSION = `sample-type-delete-permission`;

// Notifications
export const NOTIFICATION_VIEW_PERMISSION = `notification-view-permission`;
